"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingFineReasonEnum = void 0;
/** причины штрафов */
var BillingFineReasonEnum;
(function (BillingFineReasonEnum) {
  /* штраф за отмену занятия */
  BillingFineReasonEnum[BillingFineReasonEnum["cancel_meeting"] = 1] = "cancel_meeting";
})(BillingFineReasonEnum = exports.BillingFineReasonEnum || (exports.BillingFineReasonEnum = {}));
